module.exports = __webpack_public_path__ + "static/media/home-ui-ux-svgrepo-com.d3b5b439.svg";